import { createEnhancedEnum } from '../../../../global/utils/EnumBuilder';

const EMPATHIZE = {
  EMPATHIZE: 0,
};

const EmpathizeEnum = createEnhancedEnum('Empathize', EMPATHIZE);

export default EmpathizeEnum;
